import { useTranslation } from 'react-i18next';

import { dateFormatter } from 'components/shared/DataGrid/utils/valueFormatters/dateFormatter';
import { IndefiniteText } from '../Protocols.styles';
import { getProtocolDurationInWeeks } from '../Protocols.utils';

import type { ProtocolResponse } from 'generated/index';
import type { GridColDef } from '@mui/x-data-grid-pro';

export const useProtocolColumns = (): GridColDef<ProtocolResponse>[] => {
  'use memo';
  const { t } = useTranslation('common');

  return [
    {
      field: 'name',
      headerName: t('adminPortal.protocols.name'),
      hideable: false,
      flex: 1,
      minWidth: 280
    },
    {
      field: 'validFrom',
      headerName: t('adminPortal.protocols.validFrom'),
      hideable: false,
      minWidth: 140,
      valueFormatter: dateFormatter
    },
    {
      field: 'validUntil',
      headerName: t('adminPortal.protocols.validUntil'),
      hideable: false,
      minWidth: 140,
      renderCell: ({ row }) =>
        row.validUntil ? (
          dateFormatter(row.validUntil)
        ) : (
          <IndefiniteText>
            {t('adminPortal.protocols.indefinite')}
          </IndefiniteText>
        )
    },
    {
      field: 'durationInWeeks',
      headerName: t('adminPortal.protocols.durationInWeeks'),
      hideable: false,
      minWidth: 100,
      valueGetter: (_value, row) => getProtocolDurationInWeeks(row),
      valueFormatter: (weeks: number) =>
        t('adminPortal.protocols.detail.durationInWeeks', { count: weeks })
    },
    {
      field: 'rules',
      headerName: t('adminPortal.protocols.rules'),
      hideable: false,
      minWidth: 100,
      valueGetter: (_value, row) => row.rules.length
    }
  ];
};
